"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalAlertaLicenca = void 0;
var react_1 = __importDefault(require("react"));
var Botao_1 = require("../Botao/Botao");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Divider_1 = require("../Divider/Divider");
var Modal_1 = require("../Modal/Modal");
var estilosModalAlerta = require("./modal-alerta-licenca.module.scss");
//#endregion
var ModalAlertaLicenca = function (props) {
    //#region Componentes Internos
    var cabecalho = (react_1.default.createElement("div", { className: estilosModalAlerta.cabecalho },
        react_1.default.createElement("div", { className: estilosModalAlerta.titulo },
            react_1.default.createElement(Icone_1.Icone, { cor: Cores_1.Cores.MensagensDoSistema.VermelhoMU, nome: "warning", altura: "48px", largura: "48px" }),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body1", cor: Cores_1.Cores.MensagensDoSistema.VermelhoMU, negrito: 700 }, "ATEN\u00C7\u00C3O!"))));
    var corpo = (react_1.default.createElement("div", { className: estilosModalAlerta.corpo },
        react_1.default.createElement("div", { className: estilosModalAlerta.textoPrincipal },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, negrito: 700 }, "Detectamos que o aplicativo de"),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", cor: Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600, negrito: 700 }, "LICENCIAMENTO"),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, negrito: 700 }, "n\u00E3o est\u00E1 instalado em sua m\u00E1quina.")),
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, negrito: 400 }, "Portanto o acesso a partir deste dispositivo contar\u00E1 como uma nova licen\u00E7a.")));
    var botaoOk = (react_1.default.createElement(Botao_1.Botao, { estilo: 'primaryDark', onClick: function () { return props.onOk(); } },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, negrito: 700 }, "Ok")));
    var rodape = (react_1.default.createElement("div", { className: estilosModalAlerta.rodape }, botaoOk));
    //#endregion
    //#region Render
    return (react_1.default.createElement(Modal_1.Modal, { isOpen: props.isOpen, onClose: function () { return props.onFecharModal(); }, botaoFechar: false, style: __assign(__assign({}, props.style), { width: "100%", minWidth: "60vw", maxWidth: "60vw", display: "flex", alignItems: "center", backgroundColor: Cores_1.Cores.CoresIdentidadeMU.brancoMu }) },
        react_1.default.createElement("div", { className: estilosModalAlerta.container },
            cabecalho,
            react_1.default.createElement(Divider_1.Divider, { style: { backgroundColor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU300 } }),
            corpo,
            rodape)));
    //#endregion
};
exports.ModalAlertaLicenca = ModalAlertaLicenca;
